import React from 'react'

import Box from '@/modules/components/Box'
import Link from '@/modules/components/Link'

import { socials } from './data'

export const Social = () => {
  return (
    <Box
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: '32px',
      }}
    >
      {socials.map(({ href, IconComponent }) => (
        <Link key={href} href={href}>
          <IconComponent color="secondaryDarkGrey" fontSize="20px" />
        </Link>
      ))}
    </Box>
  )
}
